/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_hint_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter two valid numbers and leave one field blank. A zero where a divisor is needed has no solution.`)
};

const es_pctsol_hint_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce dos números válidos y deja un campo en blanco. Un cero donde se necesita un divisor no tiene solución.`)
};

const de_pctsol_hint_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie zwei gültige Zahlen ein und lassen Sie ein Feld leer. Eine Null, wo ein Divisor benötigt wird, ergibt keine Lösung.`)
};

const nl_pctsol_hint_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul twee geldige getallen in en laat één veld leeg. Een nul waar een deler nodig is heeft geen oplossing.`)
};

const fr_pctsol_hint_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez deux nombres valides et laissez un champ vide. Un zéro là où un diviseur est requis n'a pas de solution.`)
};

const it_pctsol_hint_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci due numeri validi e lascia un campo vuoto. Uno zero dove serve un divisore non ha soluzione.`)
};

const pt_br2_pctsol_hint_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe dois números válidos e deixe um campo em branco. Um zero onde é necessário um divisor não tem solução.`)
};

const pt_pctsol_hint_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza dois números válidos e deixe um campo em branco. Um zero onde é necessário um divisor não tem solução.`)
};

const ja_pctsol_hint_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効な数値を2つ入力し、1つの項目を空欄にしてください。除数がゼロになる場合は解が存在しません。`)
};

const zh_pctsol_hint_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入两个有效数字并留空一个字段。若除数为零则无解。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_hint_invalid = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_hint_invalid(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_hint_invalid", locale)
	if (locale === "en") return en_pctsol_hint_invalid(inputs)
	if (locale === "es") return es_pctsol_hint_invalid(inputs)
	if (locale === "de") return de_pctsol_hint_invalid(inputs)
	if (locale === "nl") return nl_pctsol_hint_invalid(inputs)
	if (locale === "fr") return fr_pctsol_hint_invalid(inputs)
	if (locale === "it") return it_pctsol_hint_invalid(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_hint_invalid(inputs)
	if (locale === "pt") return pt_pctsol_hint_invalid(inputs)
	if (locale === "ja") return ja_pctsol_hint_invalid(inputs)
	return zh_pctsol_hint_invalid(inputs)
};